/**
 * Opening the message finder from anywhere.
 *
 * Same shape as the palette: the shell owns the dialog, because it draws over
 * everything, and any screen can ask for it - the chat header, the palette,
 * a menu item - without each of them keeping its own copy.
 */

export type FinderRequest = {
  /** Which half opens first. */
  start?: 'search' | 'saved';
  /** Search this conversation first, when asked for from inside one. */
  channelId?: string;
  channelName?: string;
};

const watchers = new Set<(req: FinderRequest) => void>();

export function openFinder(req: FinderRequest = {}): void {
  watchers.forEach((fn) => fn(req));
}

export function onOpenFinder(fn: (req: FinderRequest) => void): () => void {
  watchers.add(fn);
  return () => { watchers.delete(fn); };
}
